import { useState, useCallback } from 'react';

export const useJsonSchema = () => {
  const [generatedSchema, setGeneratedSchema] = useState('');

  const generateSchemaFromObject = useCallback((obj: any): any => {
    if (obj === null) return { type: 'null' };
    if (typeof obj === 'boolean') return { type: 'boolean' };
    if (typeof obj === 'number') return { type: 'number' };
    if (typeof obj === 'string') return { type: 'string' };

    if (Array.isArray(obj)) {
      return {
        type: 'array',
        items: obj.length > 0 ? generateSchemaFromObject(obj[0]) : { type: 'string' },
      };
    }

    if (typeof obj === 'object') {
      const properties: any = {};
      const required: string[] = [];

      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          properties[key] = generateSchemaFromObject(obj[key]);
          required.push(key);
        }
      }

      return {
        type: 'object',
        properties,
        required,
      };
    }

    return { type: 'string' };
  }, []);

  const generateSchema = useCallback(
    (jsonString: string): string => {
      try {
        const parsedJson = JSON.parse(jsonString);
        const schema = generateSchemaFromObject(parsedJson);
        const schemaString = JSON.stringify(schema, null, 2);
        setGeneratedSchema(schemaString);
        return schemaString;
      } catch (error) {
        console.error('Error generating schema:', error);
        const errorSchema = JSON.stringify(
          {
            error: 'Invalid JSON format',
            message: error instanceof Error ? error.message : 'Unknown error',
          },
          null,
          2,
        );
        setGeneratedSchema(errorSchema);
        return errorSchema;
      }
    },
    [generateSchemaFromObject],
  );

  const clearSchema = useCallback(() => {
    setGeneratedSchema('');
  }, []);

  return {
    generatedSchema,
    generateSchema,
    clearSchema,
  };
};
